/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Website_LabelInputs */

const en_directory_detail_website_label = /** @type {(inputs: Directory_Detail_Website_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Website`)
};

const zh_directory_detail_website_label = /** @type {(inputs: Directory_Detail_Website_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`官网`)
};

/**
* | output |
* | --- |
* | "Website" |
*
* @param {Directory_Detail_Website_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_website_label = /** @type {((inputs?: Directory_Detail_Website_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Website_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_website_label(inputs)
	return zh_directory_detail_website_label(inputs)
});
export { directory_detail_website_label as "directory.detail.website_label" }